import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { Media } from '../../style'

function getWidthString(size) {
  if (!size) {
    throw new Error('size is a required parameter')
  }
  const width = `${Math.round((size / 12) * 10e7) / 10e5}%`
  return css`
    flex-basis: ${width};
    max-width: ${width};
  `
}
const Column = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  ${({ xs }) =>
    xs
      ? getWidthString(xs)
      : css`
          flex-basis: 100%;
          max-width: 100%;
        `};
  ${Media.greaterThan(Media.small)} {
    ${({ sm }) => sm && getWidthString(sm)};
  }
  ${Media.greaterThan(Media.medium)} {
    ${({ md }) => md && getWidthString(md)};
  }
  ${Media.greaterThan(Media.large)} {
    ${({ lg }) => lg && getWidthString(lg)};
  }
`

Column.propTypes = {
  xs: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sm: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  md: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lg: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Column
